import { render, staticRenderFns } from "./edit-roles.component.html?vue&type=template&id=ad70212a&scoped=true&"
import script from "./edit-roles.component.ts?vue&type=script&lang=ts&"
export * from "./edit-roles.component.ts?vue&type=script&lang=ts&"
import style0 from "./edit-roles.component.scss?vue&type=style&index=0&id=ad70212a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad70212a",
  null
  
)

export default component.exports